import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { OrderStatisticsChart } from './Charts';
import { MoveRight } from 'lucide-react';

const OrderStatistics = () => {
    const [loading, setLoading] = useState(true);
    return (
        <React.Fragment>
            <div className="col-span-12 card 2xl:col-span-4 2xl:row-span-2 relative">
                {loading && (
                    <div className="flex items-center justify-center h-full absolute inset-0">
                        <div className="flex flex-col items-center">
                            <div className="inline-flex size-10 rounded-full opacity-75 animate-bounce bg-custom-400"></div>
                        </div>
                    </div>
                )}
                <div className={`card-body ${loading ? 'hidden' : ''}`}>
                    <div className="flex items-center mb-3">
                        <h6 className="grow text-15">Günlük Sipariş Adetleri</h6>
                        <div className="relative">
                            <Link to="#" className="underline transition-all duration-200 ease-linear text-custom-500 hover:text-custom-600">Tümünü Gör<MoveRight className="inline-block size-4 align-middle ltr:ml-2 rtl:mr-2"></MoveRight></Link>
                        </div>
                    </div>
                    <OrderStatisticsChart chartId="orderStatisticsChart" setLoading={setLoading} />
                </div>
            </div>
        </React.Fragment>
    );
};

export default OrderStatistics;
